import React from 'react';
import './PartnerStoriesDetail.css';
import partnerStoriesData from './partnerStories.json';
import OptimizedImage from './OptimizedImage';
import LoopingVideo from './LoopingVideo';

// Gatorade
import gatoradeWebm from 'url:../../assets-optimized/redesign/partnerStories/gatorade.webm';
import gatoradeMp4 from 'url:../../assets-optimized/redesign/partnerStories/gatorade.mp4';
import gatoradeMainImg from 'url:../../assets-optimized/redesign/partnerStories/gatorade.png';
import gatoradeMainAvif from 'url:../../assets-optimized/redesign/partnerStories/gatorade.avif';
import gatoradeMainWebp from 'url:../../assets-optimized/redesign/partnerStories/gatorade.webp';
import gatoradeMobileImg from 'url:../../assets-optimized/redesign/partnerStories/gatorade_mobile.png';
import gatoradeMobileAvif from 'url:../../assets-optimized/redesign/partnerStories/gatorade_mobile.avif';
import gatoradeMobileWebp from 'url:../../assets-optimized/redesign/partnerStories/gatorade_mobile.webp';
import gatoradeLogo from 'url:../../assets-optimized/redesign/partnerStories/gatorade_logo.png';
import gatoradeLogoAvif from 'url:../../assets-optimized/redesign/partnerStories/gatorade_logo.avif';
import gatoradeLogoWebp from 'url:../../assets-optimized/redesign/partnerStories/gatorade_logo.webp';

// Visa
import visaWebm from 'url:../../assets-optimized/redesign/partnerStories/visa.webm';
import visaMp4 from 'url:../../assets-optimized/redesign/partnerStories/visa.mp4';
import visaMainImg from 'url:../../assets-optimized/redesign/partnerStories/visa_wide.png';
import visaMainAvif from 'url:../../assets-optimized/redesign/partnerStories/visa_wide.avif';
import visaMainWebp from 'url:../../assets-optimized/redesign/partnerStories/visa_wide.webp';
import visaMobileImg from 'url:../../assets-optimized/redesign/partnerStories/visa_mobile.png';
import visaMobileAvif from 'url:../../assets-optimized/redesign/partnerStories/visa_mobile.avif';
import visaMobileWebp from 'url:../../assets-optimized/redesign/partnerStories/visa_mobile.webp';
import visaLogo from 'url:../../assets-optimized/redesign/partnerStories/visa_logo.png';
import visaLogoAvif from 'url:../../assets-optimized/redesign/partnerStories/visa_logo.avif';
import visaLogoWebp from 'url:../../assets-optimized/redesign/partnerStories/visa_logo.webp';

// United
import unitedSecondaryImg from 'url:../../assets-optimized/redesign/partnerStories/united.png';
import unitedSecondaryAvif from 'url:../../assets-optimized/redesign/partnerStories/united.avif';
import unitedSecondaryWebp from 'url:../../assets-optimized/redesign/partnerStories/united.webp';
import unitedMainImg from 'url:../../assets-optimized/redesign/partnerStories/united_top_row.jpg';
import unitedMainAvif from 'url:../../assets-optimized/redesign/partnerStories/united_top_row.avif';
import unitedMainWebp from 'url:../../assets-optimized/redesign/partnerStories/united_top_row.webp';
import unitedMobileImg from 'url:../../assets-optimized/redesign/partnerStories/united_mobile.png';
import unitedMobileAvif from 'url:../../assets-optimized/redesign/partnerStories/united_mobile.avif';
import unitedMobileWebp from 'url:../../assets-optimized/redesign/partnerStories/united_mobile.webp';
import unitedLogo from 'url:../../assets-optimized/redesign/partnerStories/united_logo.png';
import unitedLogoAvif from 'url:../../assets-optimized/redesign/partnerStories/united_logo.avif';
import unitedLogoWebp from 'url:../../assets-optimized/redesign/partnerStories/united_logo.webp';

const images = {
  gatorade: {
    logo: { avif: gatoradeLogoAvif, webp: gatoradeLogoWebp, fallback: gatoradeLogo },
    img1: { avif: gatoradeMainAvif, webp: gatoradeMainWebp, fallback: gatoradeMainImg },
    img1Mobile: { avif: gatoradeMobileAvif, webp: gatoradeMobileWebp, fallback: gatoradeMobileImg },
    img2: { kind: 'video', webm: gatoradeWebm, mp4: gatoradeMp4 },
  },
  visa: {
    logo: { avif: visaLogoAvif, webp: visaLogoWebp, fallback: visaLogo },
    img1: { avif: visaMainAvif, webp: visaMainWebp, fallback: visaMainImg },
    img1Mobile: { avif: visaMobileAvif, webp: visaMobileWebp, fallback: visaMobileImg },
    img2: { kind: 'video', webm: visaWebm, mp4: visaMp4 },
  },
  united: {
    logo: { avif: unitedLogoAvif, webp: unitedLogoWebp, fallback: unitedLogo },
    img1: { avif: unitedMainAvif, webp: unitedMainWebp, fallback: unitedMainImg },
    img1Mobile: { avif: unitedMobileAvif, webp: unitedMobileWebp, fallback: unitedMobileImg },
    img2: {
      kind: 'image',
      avif: unitedSecondaryAvif,
      webp: unitedSecondaryWebp,
      fallback: unitedSecondaryImg,
    },
  },
};

const PartnerStoriesDetail = () => {
  return (
    <div className='csd-wrapper'>
      {partnerStoriesData.map((activeStudy) => {
        const imgs = images[activeStudy.id] || images.gatorade;

        return (
          <section
            id={`detail-${activeStudy.id}`}
            className='csd-section fade-in-image'
            key={`detail-${activeStudy.id}`}
          >
            <div className='csd-container'>
              {/* Top White Header */}
              <div className='csd-header-card'>
                <div className='csd-header-left'>
                  <h2 className='csd-brand-title'>{activeStudy.name}</h2>
                </div>
                <div className='csd-header-right'>
                  <p className='csd-brand-intro'>{activeStudy.description}</p>
                </div>
              </div>

              {/* Main Black Container */}
              <div className='csd-main-card'>
                {/* Top Row: Main image + Stats */}
                <div className='csd-top-row'>
                  <div className='csd-laptop-img-wrapper'>
                    {imgs.img1 && (
                      <picture>
                        {imgs.img1Mobile && (
                          <>
                            <source
                              media='(max-width: 768px)'
                              type='image/avif'
                              srcSet={imgs.img1Mobile.avif}
                            />
                            <source
                              media='(max-width: 768px)'
                              type='image/webp'
                              srcSet={imgs.img1Mobile.webp}
                            />
                            <source media='(max-width: 768px)' srcSet={imgs.img1Mobile.fallback} />
                          </>
                        )}
                        <source type='image/avif' srcSet={imgs.img1.avif} />
                        <source type='image/webp' srcSet={imgs.img1.webp} />
                        <img
                          src={imgs.img1.fallback}
                          alt={`${activeStudy.name} main`}
                          className='csd-laptop-img'
                        />
                      </picture>
                    )}
                    {imgs.logo && (
                      <OptimizedImage
                        avif={imgs.logo.avif}
                        webp={imgs.logo.webp}
                        fallback={imgs.logo.fallback}
                        className='csd-laptop-logo'
                        alt='logo'
                      />
                    )}
                  </div>

                  <div className='csd-stats-grid-wrapper'>
                    {activeStudy.mainBlockTitle ||
                      (activeStudy.title && (
                        <div className='csd-main-block-header'>
                          <h3 className='csd-main-block-title'>
                            {activeStudy.mainBlockTitle || activeStudy.title}
                          </h3>
                          {(activeStudy.mainBlockDesc || activeStudy.description) && (
                            <p className='csd-main-block-desc' style={{ whiteSpace: 'pre-line' }}>
                              {activeStudy.mainBlockDesc || activeStudy.description}
                            </p>
                          )}
                        </div>
                      ))}

                    <div className='csd-stats-grid'>
                      {activeStudy.stats &&
                        activeStudy.stats.map((stat, index) => (
                          <div key={index} className='csd-stat-item'>
                            <div className='csd-stat-value'>
                              {stat.value}
                              <span className='csd-stat-unit'>{stat.unit}</span>
                            </div>
                            <div className='csd-stat-desc' style={{ whiteSpace: 'pre-line' }}>
                              {stat.desc}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>

                {/* Bottom Row: Text card + Secondary Image */}
                {(activeStudy.detailTitle || activeStudy.detailDesc) && (
                  <div className='csd-bottom-row'>
                    <div className='csd-blue-card'>
                      <h3 className='csd-blue-title' style={{ whiteSpace: 'pre-line' }}>
                        {activeStudy.detailTitle}
                      </h3>
                      <p className='csd-blue-desc' style={{ whiteSpace: 'pre-line' }}>
                        {activeStudy.detailDesc}
                      </p>
                    </div>
                    <div className='csd-bike-img-wrapper'>
                      {imgs.img2 && imgs.img2.kind === 'video' && (
                        <LoopingVideo
                          webm={imgs.img2.webm}
                          mp4={imgs.img2.mp4}
                          className='csd-bike-img'
                        />
                      )}
                      {imgs.img2 && imgs.img2.kind === 'image' && (
                        <OptimizedImage
                          avif={imgs.img2.avif}
                          webp={imgs.img2.webp}
                          fallback={imgs.img2.fallback}
                          alt={`${activeStudy.name} secondary`}
                          className='csd-bike-img large'
                        />
                      )}
                    </div>
                  </div>
                )}

                {/* Footnotes */}
                {activeStudy.footnotes && (
                  <div className='csd-footnotes'>{activeStudy.footnotes}</div>
                )}
              </div>
            </div>
          </section>
        );
      })}
    </div>
  );
};

export default PartnerStoriesDetail;
